import { useEffect } from "react";
import { useCesium } from "../../useCesium";
import { useCurrentProjectId } from "lib/hooks/useProject";

export function useToolEffectElementRepositionProjectSync() {
  const { tilesetElementRepositionPlugin } = useCesium();
  const projectId = useCurrentProjectId();

  useEffect(() => {
    tilesetElementRepositionPlugin.setCurrentProject(projectId);
  }, [projectId, tilesetElementRepositionPlugin]);
}
